import axios from "@/api/axiosInstance";
import { GetBillingInvoicesResponse } from "../getBillingInvoices/types";

export const getBillingSubscriptionInvoices = async (
  id: string,
  signal?: AbortSignal,
): Promise<GetBillingInvoicesResponse> => {
  const response = await axios.get<GetBillingInvoicesResponse>(
    `/api/private/billing/subscriptions/${id}/invoices`,
    { signal },
  );
  return response.data;
};
